import { DEFAULT_APP_BAR_HEIGHT } from 'config/const';

export const ToolbarStyle = {
  p: '0 16px',
  minHeight: `${DEFAULT_APP_BAR_HEIGHT}px`,
  alignItems: 'center',
};
export const AppBarStyle = (theme) => ({
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: '0px',
  position: 'initial',
  // backgroundImage: `url("${BgImage}")`,
});

export const AppBarSpaceStyle = {
  flex: '1 1 auto',
};

export const OfflineMessageStyle = (theme) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  height: 15,
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
});

export const PageStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
};

export const PageContentStyle = (contentStyle) => ({
  overflow: 'hidden',
  flexDirection: 'column',
  display: 'flex',
  height: '100%',
  zIndex: 2,
  '& .content-wrapper': {
    flex: 1,
    overflow: 'hidden',
  },
  '& .content-scroll-wrapper': {
    height: '100%',
    overflow: 'scroll',
  },
  ...contentStyle,
});

export const PageAppBarVisible = (appbarHeight) => ({
  alignItems: 'center',
  justifyContent: 'flex-end',
  minHeight: appbarHeight,
});

export const RoutesMenuToolbarStyle = {
  marginBottom: 2,
  minHeight: DEFAULT_APP_BAR_HEIGHT,
};

export const LogoStyle = {
  position: 'absolute',
  left: 'calc(50% - 2em)',
};

export const BottomLineGradientStyle = {
  position: 'absolute',
  bottom: '1px',
  height: '20vh',
  width: '100%',
  background:
    'linear-gradient(180deg, rgba(178, 178, 178, 0) 0%, rgba(178, 178, 178, 0.04) 11%, rgba(178, 178, 178, 0.17) 28%, rgba(178, 178, 178, 0.37) 49%, rgba(178, 178, 178, 0.64) 73%, #B2B2B2 100%)',
};

export const RouteTitleStyle = {
  width: 'fit-content',
  display: 'block',
};

export const ListStyle = (theme) => ({
  width: '100%',
  maxWidth: 360,
  p: 0,
  bgcolor: 'background.paper',
  '&.selected hr': {
    borderBottom: `2px solid ${theme.palette.menu.selected}`,
    width: '180%',
  },
});
